import httpClient from "httpClient"

const get = (idConvenio) => {
    
    const pathname = `/especialidades/${idConvenio}`
            
    return httpClient.get(pathname)
    
}


const especialidades = {
    get,
}

export default especialidades

